export type Uid = string

export type Url = string

export type Timestamp = string

export type Email = string

export type PhoneNumber = string

export type Scope = string

export type ScopeResponse = {
  scopes: Array<Scope>
}

export type SmartFilter = (searchTerm: string) => string

export type PredictionJson = {
  id: string;
  scope: string;
  display_name: string;
  url: string;
  ingested_at: string
}

export type Prediction = {
  id: Uid;
  scope: Scope;
  displayName: string;
  url: Url;
  ingestedAt: Timestamp
}

export const predictionJsonToPrediction = (json: PredictionJson): Prediction => {
  return {
    id: json.id,
    scope: json.scope,
    displayName: json.display_name,
    url: json.url,
    ingestedAt: json.ingested_at
  }
}

export type AutoCompletionResponse = Array<PredictionJson>

export type AutoCompletionResult = {
  searchTerm: string;
  results: Array<Prediction>;
}

export type SearchResultItemJson = {
  type: string;
  id: string;
  scope: string;
  display_name: string;
  state: string;
  email: string;
  phone_numbers: Array<string>;
  url: string;
  ingested_at: string;
  details: any
}

export type SearchResultItem = {
  type: string;
  id: Uid;
  scope: Scope;
  displayName: string;
  state: string;
  email: Email;
  phoneNumbers: Array<PhoneNumber>;
  url: Url;
  ingestedAt: Timestamp;
  details: any
}

export const searchResultItemJsonToSearchResultItem = (json: SearchResultItemJson): SearchResultItem => {
  return {
    type: json.type,
    id: json.id,
    scope: json.scope,
    displayName: json.display_name,
    state: json.state,
    email: json.email,
    phoneNumbers: json.phone_numbers,
    url: json.url,
    ingestedAt: json.ingested_at,
    details: json.details
  }
}

export type SearchResultResponseJson = {
  total: number;
  results: Array<SearchResultItemJson>;
}

export type SearchResultResponse = {
  total: number;
  results: Array<SearchResultItem>;
}

export const searchResultResponseJsonToSearchResultResponse = (json: SearchResultResponseJson): SearchResultResponse => {
  return {
    total: json.total,
    results: json.results.map(searchResultItemJsonToSearchResultItem)
  }
}

export interface SearchResult {
  searchTerm: string;
  from: number;
  size: number;
  scopes: Array<Scope>;
  result: SearchResultResponse;
}

export enum SearchState {
  FetchingScopes,
  ErrorFetchingScopes,
  WaitingForInput,
  RunningAutocompletionSearch,
  CompletedAutocompletionSearch,
  ErrorAutoCompletionSearch,
  RunningGeneralSearch,
  CompletedGeneralSearch,
  ErrorGeneralSearch
}
